// Right sidebar — tabbed between Drafts and Media (08_AUTHORING_APP.md).

import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/authStore";
import { useMediaStore } from "../../store/mediaStore";
import { DraftsPane } from "./DraftsPane";
import { MediaPane } from "./MediaPane";
import { PublishPane } from "./PublishPane";

type Tab = "drafts" | "media" | "publish";

export function RightSidebar() {
  const user = useAuthStore((s) => s.user)!;
  const initMedia = useMediaStore((s) => s.init);
  const [tab, setTab] = useState<Tab>("drafts");

  useEffect(() => { void initMedia(user.sub); }, [user.sub, initMedia]);

  return (
    <div className="rs-root">
      <div className="rs-tabs">
        <button className={"rs-tab" + (tab === "drafts" ? " rs-tab-on" : "")} onClick={() => setTab("drafts")}>Drafts</button>
        <button className={"rs-tab" + (tab === "media" ? " rs-tab-on" : "")} onClick={() => setTab("media")}>Media</button>
        <button className={"rs-tab" + (tab === "publish" ? " rs-tab-on" : "")} onClick={() => setTab("publish")}>Publish</button>
      </div>
      <div className="rs-body">
        {tab === "drafts" ? <DraftsPane /> : tab === "media" ? <MediaPane /> : <PublishPane />}
      </div>
      <style>{`
        .rs-root { display: flex; flex-direction: column; height: 100%; min-height: 0; background: var(--paper-raised); border-left: 1px solid var(--line); }
        .rs-tabs { flex: none; display: flex; gap: 2px; padding: var(--space-2) var(--space-2) 0; }
        .rs-tab { flex: 1; font-family: var(--font-sans); font-size: 12px; font-weight: 600; color: var(--ink-soft); background: transparent; border: none; border-bottom: 2px solid transparent; padding: 8px; cursor: pointer; }
        .rs-tab-on { color: var(--teal); border-bottom-color: var(--teal); }
        .rs-body { flex: 1; min-height: 0; }
      `}</style>
    </div>
  );
}
